module.exports = __webpack_public_path__ + "img/4.f3dae1da.jpg";